export default __webpack_public_path__ + "static/media/client-timeline-preview.eb377ebd.svg";